/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus } from './FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus';
import {
    FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSON,
    FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSONTyped,
    FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSON,
    FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSONTyped,
} from './FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus';

/**
 * 
 * @export
 * @interface FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand
 */
export interface FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand
     */
    PublicOrderId: string;
    /**
     * 
     * @type {FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus}
     * @memberof FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand
     */
    Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus;
}



/**
 * Check if a given object implements the FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand interface.
 */
export function instanceOfFxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand(value: object): value is FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand {
    if (!('PublicOrderId' in value) || value['PublicOrderId'] === undefined) return false;
    if (!('Status' in value) || value['Status'] === undefined) return false;
    return true;
}

export function FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandFromJSON(json: any): FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand {
    return FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandFromJSONTyped(json, false);
}

export function FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'PublicOrderId': json['PublicOrderId'],
        'Status': FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusFromJSON(json['Status']),
    };
}

export function FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandToJSON(json: any): FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand {
    return FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandToJSONTyped(json, false);
}

export function FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommandToJSONTyped(value?: FxIdApplicationOrdersOrdersSetOptimisticOrderStatusCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PublicOrderId': value['PublicOrderId'],
        'Status': FxIdDomainModelsDBStoreDBOrderOptimisticUserStatusToJSON(value['Status']),
    };
}

